/**
 * Frontend JavaScript for Accordion Block
 */
(function () {
    'use strict';

    function initAccordions() {
        const accordionBlocks = document.querySelectorAll('.wp-block-faqmate-faq, .wp-block-faqmate-heading, [class*="asfa-block-"]');

        if (accordionBlocks.length === 0) {
            return;
        }

        accordionBlocks.forEach(block => {
            const accordionItems = block.querySelectorAll('.single-faq');

            accordionItems.forEach((item, index) => {
                const head = item.querySelector('.asfa__head');
                const body = item.querySelector('.asfa__body');
                const icon = item.querySelector('.asfa__icon');

                if (!head || !body) {
                    return;
                }

                // Remove any existing event listeners by cloning
                const newHead = head.cloneNode(true);
                head.parentNode.replaceChild(newHead, head);

                // Click event handler
                newHead.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleAccordion(item, newHead, body, icon, block);
                });

                // Keyboard accessibility (Enter and Space)
                newHead.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleAccordion(item, newHead, body, icon, block);
                    }
                });

                // Set cursor pointer and prevent text selection
                newHead.style.cursor = 'pointer';
                newHead.style.userSelect = 'none';
            });
        });
    }

    /**
     * Toggle Accordion Function
     */
    function toggleAccordion(item, head, body, icon, block) {
        const isActive = item.classList.contains('asfa__active_accordion');

        // Get the position before toggle
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        const itemRect = item.getBoundingClientRect();
        const itemTopRelativeToViewport = itemRect.top;
        const viewportCenter = window.innerHeight / 2;
        const isAboveCenter = itemTopRelativeToViewport < viewportCenter;

        if (isActive) {
            // Close accordion
            item.classList.remove('asfa__active_accordion');
            body.classList.remove('asfa__active');
            if (icon) icon.classList.remove('asfa__active_icon');
            head.setAttribute('aria-expanded', 'false');

            // Get current height
            const currentHeight = body.scrollHeight;

            // Set explicit height before transition
            body.style.height = currentHeight + 'px';
            body.style.overflow = 'hidden';
            body.style.transition = 'height 0.3s ease-in-out';

            // Force browser reflow
            void body.offsetHeight;

            // Start collapse animation
            requestAnimationFrame(() => {
                body.style.height = '0px';
            });

            // Clean up after animation
            setTimeout(() => {
                body.style.display = 'none';
                body.style.height = '';
                body.style.overflow = '';
                body.style.transition = '';
            }, 300);
        } else {
            // Open accordion
            item.classList.add('asfa__active_accordion');
            body.classList.add('asfa__active');
            if (icon) icon.classList.add('asfa__active_icon');
            head.setAttribute('aria-expanded', 'true');

            // Prepare for animation
            body.style.display = 'block';
            body.style.height = '0px';
            body.style.overflow = 'hidden';
            body.style.transition = 'height 0.3s ease-in-out';

            // Get target height
            const targetHeight = body.scrollHeight;

            // Force browser reflow
            void body.offsetHeight;

            // Start expand animation
            requestAnimationFrame(() => {
                body.style.height = targetHeight + 'px';

                // Only adjust scroll if accordion is in upper part of viewport
                if (isAboveCenter && itemTopRelativeToViewport < 100) {
                    const expansionHeight = targetHeight;
                    const scrollAdjustment = expansionHeight * 0.3;

                    const adjustScroll = (timestamp, startTime, duration) => {
                        if (!startTime) startTime = timestamp;
                        const elapsed = timestamp - startTime;
                        const progress = Math.min(elapsed / duration, 1);

                        // Ease-out function
                        const easeOut = 1 - Math.pow(1 - progress, 3);
                        const newScroll = scrollY + scrollAdjustment * easeOut;

                        window.scrollTo(0, newScroll);

                        if (progress < 1) {
                            requestAnimationFrame(ts => adjustScroll(ts, startTime, duration));
                        }
                    };

                    requestAnimationFrame(ts => adjustScroll(ts, null, 300));
                } else {
                    window.scrollTo(0, scrollY);
                }
            });

            // Clean up after animation
            setTimeout(() => {
                body.style.height = 'auto';
                body.style.overflow = '';
                body.style.transition = '';
            }, 300);
        }
    }

    // Prevent default anchor behavior
    document.addEventListener(
        'click',
        function (e) {
            const target = e.target.closest('.asfa__head');
            if (target) {
                e.preventDefault();
                return false;
            }
        },
        true
    );

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAccordions);
    } else {
        initAccordions();
    }

    // Also try after a short delay (for dynamic content)
    setTimeout(initAccordions, 100);

    // Re-initialize on dynamic content changes
    if (typeof MutationObserver !== 'undefined') {
        const observer = new MutationObserver(function (mutations) {
            let shouldReinit = false;
            mutations.forEach(function (mutation) {
                if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(function (node) {
                        if (
                            node.nodeType === 1 &&
                            node.classList &&
                            (node.classList.contains('wp-block-faqmate-faq') || node.querySelector('.wp-block-faqmate-faq'))
                        ) {
                            shouldReinit = true;
                        }
                    });
                }
            });

            if (shouldReinit) {
                initAccordions();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
})();
